import { ref } from 'vue';
import { apiLink } from './apiLink'
import { deleteData, getData, postData, patchData, putData } from './generalio';

const projects = () => {
    const projects = ref([])
    const error = ref(null)
    const host = ref (apiLink + '/project/')
    
 const allowedClients = () => {
        let endpoint = `project/cids`
        console.log(endpoint, "### cids")
        return getData(endpoint, "allowedClients", [])
            .catch(err => {
                let msg = `ERROR fn: allowedClients: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }    
    const loadData = () => {
        //api/project/{id}/data

        let endPoint = `project`

        return getData(endPoint, "data", [])
            .catch(err => {
                let msg = `ERROR fn: loadData: ${err}`
                console.log(msg)
                throw Error(msg)
            })

    }
    
    // patch method
    const updateEntry = (row) => {

        if(row.id === ''){
            createEntry(row)
            return
        }
        let oldEntry = getEntry(row.id)
        for (const property in row) {
            oldEntry[property] = row[property]
        }

        let endPoint = `project/${row.id}`
        //can't find endpoint, guessing this is what it might say
        let my404answer = "can't find database record of id " + row.id

        patchData(endPoint, oldEntry, "entry", my404answer)
            .catch(err => {
                let msg = `ERROR fn: updateEntry: ${err}`
                console.log(msg)
                throw Error(msg)
            })

    }
    
    const getEntry = (id) => {

        let endPoint = `project/${id}`
        let my404answer = "no results found for entry"

        return getData(endPoint, "entry", [])
            .catch(err => {
                let msg = `ERROR fn: getEntry: ${err}`
                console.log(msg)
                throw Error(msg)
            })

    }
    
     const createEntry = (row) => {

        let endPoint = `project`

        return postData(endPoint, row, "entry", null)
            .then (r => {
                if (r != null && r != undefined) {
                    return r
                }
                //the stuff below should never happen - but lets put something here
                throw Error ('Entry postData had bad data fed into the /project end point' + JSON.stringify(r))
            })
            .catch(err => {
                let msg = `ERROR fn: createEntry: ${err}`
                console.log(msg)
                throw Error(msg)
            })

     }

    const deleteEntry2 = (id) => {

        let endPoint = `project/${id}`
        let my404answer = "can't find database record of id " + id

        return deleteData(endPoint, "entry", -1)
            .then(r => {
                if (r != id) {
                    throw Error('id returned from deleteEntry2 is different than the one we wrote to' + JSON.stringify(r))
                }
                return r
            })
            .catch(err => {
                let msg = `ERROR fn: deleteEntry2: ${err}`
                console.log(msg)
                throw Error(msg)
            })

    }

    const deleteEntry = (id) => {

        let endPoint = `project/${id}`

        return deleteData(endPoint, "entry", -1)
            .then(r => {
                if (r != id) {
                    throw Error('id returned from deleteEntry is different than the one we wrote to' + JSON.stringify(r))
                }
                return r
            })
            .catch(err => {
                let msg = `ERROR fn: deleteEntry: ${err}`
                console.log(msg)
                throw Error(msg)
            })

    }

    const loadActiveRegions = (projectid) => {

        let endPoint = `project/${projectid.toString()}/activeregions`

        return getData(endPoint, "active regions", [])
            .catch(err => {
                let msg = `ERROR fn: loadActiveRegions: ${err}`
                console.log(msg)
                throw Error(msg)
            })

    }

    const saveActiveRegions = (projectId, itemsToSendBack) => {

        let endPoint = `project/${projectId.toString()}/activeregions`

        return postData(endPoint, itemsToSendBack, "active regions", null)
            .then(r => {
                if (r != null && r != undefined) {
                    return r
                }
                //the stuff below should never happen - but lets put something here
                throw Error ('ActiveRegions postData had bad data fed into the /project/{projectId}/activeregions end point' + JSON.stringify(r))
            })
            .catch(err => {
                let msg = `ERROR fn: saveActiveRegions: ${err}`
                console.log(msg)
                throw Error(msg)
            })

        
    }
    const loadDataPromise = (projectid) => {

        // let endPoint = `project/${projectid}`
        let endPoint = 'project/' + projectid.toString()

        return getData(endPoint, "data promise", [])
            .catch(err => {
                let msg = `ERROR fn: loadDataPromise: ${err}`
                console.log(msg)
                throw Error(msg)
            })

    }

    const addOrUpdateUserPreference = (projectId, preference, content) => {
        const endpoint = `project/${preference}/${projectId}`

        return putData(endpoint, JSON.stringify(content), 'user preferences', -1)
            .then(r => {
                if (r == -1) {
                    throw Error('user preference failed to save')
                }

                return r
            })
            .catch(err => {
                let msg = `ERROR fn: addOrUpdateuserPreference: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }

    const getUserPreferences = (projectId, userPreferencesCSV) => {
        const endpoint = `project/${userPreferencesCSV}/${projectId}`

        return getData(endpoint, 'user preferences', {})
            .then(r => {
                let errorMsg = ''
                let sep = ''
                
                console.log("We have preferences: ", r)


                /**
                 * r --> {
                 *  preference: {
                 *      pId: content, //this will be in here only if no errors occured
                 *      -1/-2: error msg
                 *  }
                 * }
                 */

                userPreferencesCSV.split(',').forEach(preference => {

                    for (const returnVal in r[preference]) {
                        if (!r[preference].hasOwnProperty(projectId)) {
                            //something happened fetching the preference
                            // console.log(msg, r[preference], r[preference][msg])
                            errorMsg += sep + r[preference][returnVal] + "; "
                            sep = '\n'
                        } else {

                            //anything other than a string will work
                            //if a string comes along, just use it
                            try {
                                r[preference] = JSON.parse(r[preference][projectId])
                            }
                            catch(err) {
                                r[preference] = r[preference][projectId]
                            }
                        }
                    }
                })


                if (errorMsg != '') {
                    // console.log(errorMsg)
                    return errorMsg
                } else if (Object.keys(r).length == 1) {
                    return r[userPreferencesCSV] //there was only one preference
                } else {
                    return r
                }
            })
            .catch(err => {
                const msg = "ERROR fn: getuserPreferences: " + err
                console.log(msg)
                throw Error(msg)
            })
    }

    return { allowedClients, error, loadData, loadDataPromise, updateEntry, getEntry, createEntry, deleteEntry, loadActiveRegions, saveActiveRegions, addOrUpdateUserPreference, getUserPreferences }
}

export default projects
